(function () {
  'use strict';

  var states = new WeakMap();

  function visibleCount(carousel) {
    var match = carousel.className.match(/column-(\d+)/);
    var desktop = match ? parseInt(match[1], 10) : 4;
    var width = window.innerWidth;

    if (width >= 1100) return desktop;
    if (width >= 992) return 4;
    if (width >= 551) return 3;
    return 2;
  }

  function getState(carousel) {
    var state = states.get(carousel);
    if (!state) {
      state = { index: 0 };
      states.set(carousel, state);
    }
    return state;
  }

  function setPosition(carousel, animate) {
    var items = carousel.querySelectorAll('.halo-item:not(.halo-item-full)');
    if (!items.length) return;

    var state = getState(carousel);
    var maxIndex = Math.max(0, items.length - visibleCount(carousel));
    state.index = Math.min(state.index, maxIndex);

    var step = items.length > 1
      ? items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left
      : items[0].getBoundingClientRect().width;

    carousel.style.transition = animate ? 'transform .45s ease' : 'none';
    carousel.style.transform = 'translate3d(' + (-state.index * step) + 'px, 0, 0)';
    carousel.dataset.xploraCarouselIndex = String(state.index);
  }

  function resetCarousel(carousel) {
    if (!carousel) return;
    getState(carousel).index = 0;
    window.requestAnimationFrame(function () {
      setPosition(carousel, false);
    });
  }

  function advanceSection(section) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var carousel = section.querySelector('.tab-pane.active [data-xplora-product-carousel]');
    if (!carousel || carousel.matches(':hover') || carousel.contains(document.activeElement)) return;

    var items = carousel.querySelectorAll('.halo-item:not(.halo-item-full)');
    var maxIndex = Math.max(0, items.length - visibleCount(carousel));
    if (maxIndex < 1) return;

    var state = getState(carousel);
    state.index = state.index >= maxIndex ? 0 : state.index + 1;
    setPosition(carousel, true);
  }

  function activateTab(section, tab) {
    var tabs = section.querySelectorAll('[data-xplora-shop-tab]');
    var panes = section.querySelectorAll('.tab-content > .tab-pane');
    var target = tab.getAttribute('href');
    var pane = target && target.charAt(0) === '#' ? document.getElementById(target.slice(1)) : null;

    if (!pane || !section.contains(pane)) return;

    tabs.forEach(function (item) {
      var active = item === tab;
      item.classList.toggle('active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
      item.setAttribute('tabindex', active ? '0' : '-1');
    });

    panes.forEach(function (item) {
      var active = item === pane;
      item.classList.toggle('active', active);
      item.classList.toggle('show', active);
      item.setAttribute('aria-hidden', active ? 'false' : 'true');

      var carousel = item.querySelector('[data-xplora-product-carousel]');
      if (carousel && !active) {
        getState(carousel).index = 0;
        carousel.style.transform = '';
        carousel.dataset.xploraCarouselIndex = '0';
      }
    });

    resetCarousel(pane.querySelector('[data-xplora-product-carousel]'));
  }

  function initSection(section) {
    if (section.dataset.xploraShopNowReady === 'true') return;

    var tabs = section.querySelectorAll('[data-xplora-shop-tab]');
    if (!tabs.length) return;

    section.dataset.xploraShopNowReady = 'true';

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        activateTab(section, tab);
      });
    });

    activateTab(section, section.querySelector('[data-xplora-shop-tab].active') || tabs[0]);
    section.xploraCarouselTimer = window.setInterval(function () {
      advanceSection(section);
    }, 3000);
  }

  function initAll(scope) {
    var root = scope || document;
    var sections = [];

    if (root.matches && root.matches('[data-xplora-shop-now]')) sections.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-xplora-shop-now]').forEach(function (section) {
        sections.push(section);
      });
    }

    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('[data-xplora-shop-now]');
    if (section && section.xploraCarouselTimer) window.clearInterval(section.xploraCarouselTimer);
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-xplora-shop-now] .tab-pane.active [data-xplora-product-carousel]').forEach(function (carousel) {
      setPosition(carousel, false);
    });
  });
})();